import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _defineMessages;

import { defineMessages } from "@formatjs/intl";
export default defineMessages((_defineMessages = {
  payment: {
    id: "payment.payment",
    defaultMessage: "Payment"
  },
  coligoPayment: {
    id: "payment.coligoPayment",
    defaultMessage: "Coligo Payment"
  },
  paymentSettings: {
    id: "payment.paymentSettings",
    defaultMessage: "Payment Settings"
  },
  paymentCategories: {
    id: "payment.paymentCategories",
    defaultMessage: "Payment Categories"
  },
  payments: {
    id: "payment.payments",
    defaultMessage: "Payments"
  },
  created: {
    id: "payment.created",
    defaultMessage: "Created"
  },
  categorySuccessfuly: {
    id: "payment.categorySuccessfuly",
    defaultMessage: "Payment Category Successfuly"
  },
  paymentCategory: {
    id: "payment.paymentCategory",
    defaultMessage: "Payment Category"
  },
  categoryName: {
    id: "payment.categoryName",
    defaultMessage: "Category Name"
  },
  deleteCategoryMessage: {
    id: "payment.deleteCategoryMessage",
    defaultMessage: "Are you sure you want to delete this category? You will not be able to recover it!"
  },
  addPaymentCategory: {
    id: "payment.addPaymentCategory",
    defaultMessage: "Add Payment Category"
  },
  saved: {
    id: "payment.saved",
    defaultMessage: "Saved"
  },
  paymentSettingSuccesful: {
    id: "payment.paymentSettingSuccesful",
    defaultMessage: "Payment Setting Successfully"
  },
  paymentAPIKey: {
    id: "payment.paymentAPIKey",
    defaultMessage: "Payment API key"
  },
  transactionRate: {
    id: "payment.transactionRate",
    defaultMessage: "Transaction Rate"
  },
  maximumAmount: {
    id: "payment.maximumAmount",
    defaultMessage: "Maximum Amount"
  },
  minimumAmount: {
    id: "payment.minimumAmount",
    defaultMessage: "Minimum Amount"
  },
  paymentAvailable: {
    id: "payment.paymentAvailable",
    defaultMessage: "Payment Available"
  },
  noPaymentAvailable: {
    id: "payment.noPaymentAvailable",
    defaultMessage: "No Payment Available"
  },
  deadline: {
    id: "payment.deadline",
    defaultMessage: "Deadline"
  },
  serviceFee: {
    id: "payment.serviceFee",
    defaultMessage: "Service Fee"
  },
  amount: {
    id: "payment.amount",
    defaultMessage: "Amount"
  },
  egyptianCurrency: {
    id: "payment.egyptianCurrency",
    defaultMessage: "LE"
  },
  payNow: {
    id: "payment.payNow",
    defaultMessage: "Pay Now"
  },
  availablePayments: {
    id: "payment.availablePayments",
    defaultMessage: "Available Payments"
  },
  myPayments: {
    id: "payment.myPayments",
    defaultMessage: "My Payments"
  },
  listAvailablePayment: {
    id: "payment.listAvailablePayment",
    defaultMessage: "List of your available payment."
  },
  "export": {
    id: "payment.export",
    defaultMessage: "Export"
  },
  totalPaid: {
    id: "payment.totalPaid",
    defaultMessage: "Total paid"
  },
  paid: {
    id: "payment.paid",
    defaultMessage: "Paid"
  },
  //
  invoices: {
    id: "payment.invoices",
    defaultMessage: "Invoices"
  },
  studentName: {
    id: "payment.studentName",
    defaultMessage: "Student Name"
  },
  paymentDate: {
    id: "payment.paymentDate",
    defaultMessage: "Payment Date"
  },
  invoiceName: {
    id: "payment.invoiceName",
    defaultMessage: "Invoice Name"
  },
  paymentMethod: {
    id: "payment.paymentMethod",
    defaultMessage: "Payment Method"
  },
  studentTable: {
    id: "payment.studentTable",
    defaultMessage: "Student Table"
  },
  summaryOfInfo: {
    id: "payment.summaryOfInfo",
    defaultMessage: "Summary of the most important info for school admins."
  },
  noDataPayment: {
    id: "payment.noDataPayment",
    defaultMessage: "No Data for this Payment"
  },
  paymentName: {
    id: "payment.paymentName",
    defaultMessage: "Payment Name"
  },
  paymentNameRequired: {
    id: "payment.paymentNameRequired",
    defaultMessage: "Payment name is required"
  },
  paymentNameCharacters: {
    id: "payment.paymentNameCharacters",
    defaultMessage: "Payment name must be at least 4 characters"
  },
  paymentDesc: {
    id: "payment.paymentDesc",
    defaultMessage: "Payment description"
  },
  paymentDescRequired: {
    id: "payment.paymentDescRequired",
    defaultMessage: "Payment description is required"
  },
  paymentDescCharacters: {
    id: "payment.paymentDescCharacters",
    defaultMessage: "Payment description must be at least 5 characters"
  },
  defaultAmount: {
    id: "payment.defaultAmount",
    defaultMessage: "Default Amount (EGP)"
  },
  defaultAmountRequired: {
    id: "payment.defaultAmountRequired",
    defaultMessage: "Default Amount is required"
  },
  importCsv: {
    id: "payment.importCsv",
    defaultMessage: "Import CSV"
  },
  paymentDeadlineDate: {
    id: "payment.paymentDeadlineDate",
    defaultMessage: "Payment Deadline & Time"
  },
  paymentPublishDate: {
    id: "payment.paymentPublishDate",
    defaultMessage: "Payment Publishing Date & Time"
  },
  school: {
    id: "payment.school",
    defaultMessage: "School"
  },
  serviceFeeRequired: {
    id: "payment.serviceFeeRequired",
    defaultMessage: "Service fee is required"
  },
  saveAsDefault: {
    id: "payment.saveAsDefault",
    defaultMessage: "Save As Default"
  },
  availablility: {
    id: "payment.availablility",
    defaultMessage: "Availability"
  },
  showPayment: {
    id: "payment.showPayment",
    defaultMessage: "Show Payment"
  },
  paymobMethod: {
    id: "payment.paymobMethod",
    defaultMessage: "Online (Paymob)"
  },
  parentsDefault: {
    id: "payment.parentsDefault",
    defaultMessage: "Parents (Default)"
  },
  mustSelectPerson: {
    id: "payment.mustSelectPerson",
    defaultMessage: "must select at least one person"
  },
  selectCategory: {
    id: "payment.selectCategory",
    defaultMessage: "Select Payment Category"
  },
  noCategories: {
    id: "payment.noCategories",
    defaultMessage: "No Categories"
  },
  mustSelectCategory: {
    id: "payment.mustSelectCategory",
    defaultMessage: "Must select payment category"
  },
  paymentDetails: {
    id: "payment.paymentDetails",
    defaultMessage: "Payment Details"
  },
  paymentAudience: {
    id: "payment.paymentAudience",
    defaultMessage: "Payment Audience"
  },
  fillRequiredFields: {
    id: "payment.fillRequiredFields",
    defaultMessage: "Please fill all required fields"
  },
  addPayment: {
    id: "payment.addPayment",
    defaultMessage: "Add Payment"
  },
  importingFailed: {
    id: "payment.importingFailed",
    defaultMessage: "Importing failed, try again"
  },
  addNewPayment: {
    id: "payment.addNewPayment",
    defaultMessage: "Add new Payment"
  },
  cantUpdateCSV: {
    id: "payment.cantUpdateCSV",
    defaultMessage: "Can't Update, Uploaded CSV doesn't match Schema"
  },
  csvImported: {
    id: "payment.csvImported",
    defaultMessage: "CSV Imported"
  },
  downloadCSV: {
    id: "payment.downloadCSV",
    defaultMessage: "Download CSV"
  },
  importAgain: {
    id: "payment.importAgain",
    defaultMessage: "Import Again"
  },
  discard: {
    id: "payment.discard",
    defaultMessage: "Discard"
  },
  paymentAmount: {
    id: "payment.paymentAmount",
    defaultMessage: "Payment Amount"
  },
  customerInvoiceName: {
    id: "payment.customerInvoiceName",
    defaultMessage: "Customer's Invoice Name"
  },
  savePayment: {
    id: "payment.savePayment",
    defaultMessage: "Save Payment"
  },
  refund: {
    id: "payment.refund",
    defaultMessage: "Refund"
  },
  voided: {
    id: "payment.voided",
    defaultMessage: "Voided"
  },
  paymob: {
    id: "payment.paymob",
    defaultMessage: "Paymob"
  },
  expired: {
    id: "payment.expired",
    defaultMessage: "Expired"
  },
  selectOrCsvError: {
    id: "payment.selectOrCsvError",
    defaultMessage: "Please select students or import csv file"
  },
  latestPublishDate: {
    id: "payment.latestPublishDate",
    defaultMessage: "Latest (Publish date)"
  },
  earliestPublishDate: {
    id: "payment.earliestPublishDate",
    defaultMessage: "Earliest (Publish date)"
  },
  maxAmount: {
    id: "payment.maxAmount",
    defaultMessage: "Maximum amount"
  },
  minAmount: {
    id: "payment.minAmount",
    defaultMessage: "Minimum amount"
  },
  newestExpiryDate: {
    id: "payment.newestExpiryDate",
    defaultMessage: "Newest (Expiry date)"
  },
  oldestExpiryDate: {
    id: "payment.oldestExpiryDate",
    defaultMessage: "Oldest (Expiry date)"
  },
  latestCreatedDate: {
    id: "payment.latestCreatedDate",
    defaultMessage: "Latest (Created date)"
  },
  earliestCreatedDate: {
    id: "payment.earliestCreatedDate",
    defaultMessage: "Earliest (Created date)"
  },
  allPaymentStatus: {
    id: "payment.allPaymentStatus",
    defaultMessage: "All Payment Status"
  },
  minAmountLessThanMax: {
    id: "payment.minAmountLessThanMax",
    defaultMessage: "Minimum Amount has to be less than Maximum Amount"
  },
  maxAmountGreaterThanMin: {
    id: "payment.maxAmountGreaterThanMin",
    defaultMessage: "Maximum Amount cant be less than Minimum Amount"
  },
  listOfStudent: {
    id: "payment.listOfStudent",
    defaultMessage: "List of student payments"
  },
  paymentStatus: {
    id: "payment.paymentStatus",
    defaultMessage: "Payment Status"
  },
  sortBy: {
    id: "payment.sortBy",
    defaultMessage: "Sort By"
  },
  paymentSuccesfullyCreated: {
    id: "payment.paymentSuccesfullyCreated",
    defaultMessage: "Payment Successfully Created"
  },
  deadlineGreaterThanPublish: {
    id: "payment.deadlineGreaterThanPublish",
    defaultMessage: "Deadline date must be greater than publish date"
  },
  deadlineRequired: {
    id: "payment.deadlineRequired",
    defaultMessage: "Deadline date is required"
  },
  deadlineGreaterThanCurrent: {
    id: "payment.deadlineGreaterThanCurrent",
    defaultMessage: "Deadline date must be greater than current date"
  },
  publishDateRequired: {
    id: "payment.publishDateRequired",
    defaultMessage: "Publish date is required"
  },
  publishDateLessThanDeadline: {
    id: "payment.publishDateLessThanDeadline",
    defaultMessage: "Publish date must be less than deadline date"
  },
  paymentCategoryRequired: {
    id: "payment.paymentCategoryRequired",
    defaultMessage: "Payment category is required"
  },
  paymentRepublishLabel: {
    id: "payment.paymentRepublishLabel",
    defaultMessage: "Republish"
  },
  paymentSuccessfullyRepublished: {
    id: "payment.paymentSuccessfullyRepublished",
    defaultMessage: "Payment Successfully Republished"
  },
  paymentSuccessfullyDeleted: {
    id: "payment.paymentSuccessfullyDeleted",
    defaultMessage: "Payment Successfully Deleted"
  },
  paymentDeleteConfirmation: {
    id: "payment.paymentDeleteConfirmation",
    defaultMessage: "You will not be able to recover this Payment!"
  },
  paymentSelectDeadline: {
    id: "payment.paymentSelectDeadline",
    defaultMessage: "Select payment deadline date"
  },
  noInvoicesLabel: {
    id: "payment.noInvoicesLabel",
    defaultMessage: "No invoices"
  },
  listPaymentsTypography: {
    id: "payment.listPaymentsTypography",
    defaultMessage: "List of your payments"
  },
  paymentSuccessfullyPaid: {
    id: "payment.paymentSuccessfullyPaid",
    defaultMessage: "Successfully paid"
  },
  PaymentSuccessfullyCancelled: {
    id: "payment.PaymentSuccessfullyCancelled",
    defaultMessage: "Payment Successfully Cancelled"
  },
  paymentSuccessfullyPaidMessage: {
    id: "payment.paymentSuccessfullyPaidMessage",
    defaultMessage: "You have successfully paid this payment"
  },
  paymentCheckPaymentMessage: {
    id: "payment.paymentCheckPaymentMessage",
    defaultMessage: 'You can check your payment status by visiting the "My Payments" tab'
  },
  paymentFailed: {
    id: "payment.paymentFailed",
    defaultMessage: "Payment Failed"
  },
  paymentFailedMessage: {
    id: "payment.paymentFailedMessage",
    defaultMessage: "Unfortunately, your payment attempt has failed. Please review the payment details and try again."
  },
  paymentDashboardButton: {
    id: "payment.paymentDashboardButton",
    defaultMessage: "Go To Dashboard"
  },
  nationalIdError: {
    id: "payment.nationalIdError",
    defaultMessage: "Please make sure that 'National ID' column is filled"
  },
  paymentHistory: {
    id: "payment.paymentHistory",
    defaultMessage: "Payment History"
  },
  noAvailablePayments: {
    id: "payment.noAvailablePayments",
    defaultMessage: "No Available Payments"
  },
  successFullPayment: {
    id: "payment.successFullPayment",
    defaultMessage: "Successful Payment"
  },
  successfulPaymentMessage: {
    id: "payment.successfulPaymentMessage",
    defaultMessage: "Thank you for using Coligo!"
  },
  paymentIdTypography: {
    id: "payment.paymentIdTypography",
    defaultMessage: "Payment ID"
  },
  forStudentTypography: {
    id: "payment.forStudentTypography",
    defaultMessage: "For Student"
  }
}, _defineProperty(_defineMessages, "serviceFee", {
  id: "payment.serviceFee",
  defaultMessage: "Service Fee"
}), _defineProperty(_defineMessages, "totalAmount", {
  id: "payment.totalAmount",
  defaultMessage: "Total Amount"
}), _defineProperty(_defineMessages, "declinedPayment", {
  id: "payment.declinedPayment",
  defaultMessage: "Declined Payment"
}), _defineProperty(_defineMessages, "declinedPaymentMessage", {
  id: "payment.declinedPaymentMessage",
  defaultMessage: "Sorry! There was an issue processing payment. Click Try Again."
}), _defineProperty(_defineMessages, "searchPayments", {
  id: "payment.searchPayments",
  defaultMessage: "Search Payments"
}), _defineProperty(_defineMessages, "noPaymentHistory", {
  id: "payment.noPaymentHistory",
  defaultMessage: "No payment history"
}), _defineProperty(_defineMessages, "declinedPaymentLabel", {
  id: "payment.declinedPaymentLabel",
  defaultMessage: "Declined Payment. Click Pay Again."
}), _defineProperty(_defineMessages, "includeServiceFee", {
  id: "payment.includeServiceFee",
  defaultMessage: "Inc. Service Fee"
}), _defineProperty(_defineMessages, "viewDetailsTypography", {
  id: "payment.viewDetailsTypography",
  defaultMessage: "View Details"
}), _defineProperty(_defineMessages, "payAgainTypography", {
  id: "payment.payAgainTypography",
  defaultMessage: "Pay Again"
}), _defineProperty(_defineMessages, "confirmPayment", {
  id: "payment.confirmPayment",
  defaultMessage: "Confirm Payment"
}), _defineMessages));